module.exports = __webpack_public_path__ + "img/MB_W_Display.8c5801e0.jpg";